import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { useDispatch, useSelector } from "react-redux";
import { addfilter, productlistdata } from "../../../Reducer/productReducer";
import { default as MuiSlider } from '@mui/material/Slider';

const Productfilter2 = ({ data, index, range }) => {

  const pathname = window.location.pathname;
  const newRange = range;
  // const newRange= pathname?.includes("gift-250") ? [1,250] : pathname?.includes("gift-500") ? [1,500] : range;

  const dispatch = useDispatch();
  const addedfilter = useSelector(state => state.persistedReducer.product.addedfilter)
  const [priceRange, setpriceRange] = React.useState(addedfilter.filter(e=>e.title==="Price")?.[0]?.filter.length===0 ? range : addedfilter.filter(e=>e.title==="Price")?.[0]?.filter);

  useEffect(()=>{
    setpriceRange(addedfilter.filter(e=>e.title==="Price")?.[0]?.filter.length===0 ? range : addedfilter.filter(e=>e.title==="Price")?.[0]?.filter)
  },[addedfilter.filter(e=>e.title==="Price")?.[0]?.filter.length])

  const [val1, setVal1] = useState(data?.title == "Carat" ? [Object.keys(newRange)[0], Object.keys(newRange)[Object.keys(newRange).length - 1]] : newRange);

  const temp = addedfilter?.filter(d => d?.title == "Carat");
  const tempPrice = addedfilter?.filter(d => d?.title == "Price");
  useEffect(() => {

    data?.title == "Carat" ? (
      temp[0]?.filter?.length > 0 ?
        setVal1([getKeyByValue(newRange, temp[0]?.filter[0]), getKeyByValue(newRange, temp[0]?.filter[temp[0]?.filter?.length - 1])]) :
        setVal1([getKeyByValue(newRange, Object.values(newRange)[0]), getKeyByValue(newRange, Object.values(newRange)[(Object.values(newRange))?.length - 1])])) :
      tempPrice[0]?.filter?.length > 0 ?
        setVal1([tempPrice[0]?.filter[0], tempPrice[0]?.filter[1]]) :
        setVal1(newRange)
  }, [])
  function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
  const rangefilter = (e, title, sliderType) => {

    if (sliderType === "mui") {
      var filterdata = [];
      var changedata = [...addedfilter];
      addedfilter?.map((val) => {
        if (val.title == title && val.title == "Carat") {
          filterdata = datasort(newRange, priceRange[0], priceRange[1]);
          setVal1(e);
        } else if (val.title == title) {
          filterdata = [priceRange[0], priceRange[1]];
          setVal1([priceRange[0], priceRange[1]]);
        }
        changedata = changedata.map((obj) =>
          obj.title == title
            ? Object.assign({}, obj, { filter: filterdata, name: filterdata })
            : obj
        );
        dispatch(productlistdata([]));
        dispatch(addfilter(changedata));
      })
    } else {
      var filterdata = [];
      var changedata = [...addedfilter];
      addedfilter?.map((val) => {
        if (val.title == title && val.title == "Carat") {
          filterdata = datasort(newRange, e[0], e[1]);
          setVal1(e);
        } else if (val.title == title) {
          filterdata = [e.from_value, e.to_value];
          setVal1([e.from_value, e.to_value]);
        }
        changedata = changedata.map((obj) =>
          obj.title == title
            ? Object.assign({}, obj, { filter: filterdata, name: filterdata })
            : obj
        );
        dispatch(productlistdata([]));
        dispatch(addfilter(changedata));
      })
    }


  }
  const datasort = (obj, min, max) => {
    var data = Object.keys(obj)?.map((key) => [Number(key), obj[key]]);
    var result = [];
    var data1 = data
      .filter((val) => val[0] >= min && val[0] <= max)
      ?.map((val) => result.push(val[1]));
    return result;
  };
  // const handlecarat = (value) => {
  //   if (value[0] != value[1]) {
  //     var obj = filter?.normal_filters?.carat;
  //     var data = datasort(obj, value[0], value[1]);
  //   }
  // };



  const handleChange = (event, newValue) => {
    setpriceRange(newValue);
  };

  return (
    <Container className='carat_filter'>
      {data?.data?.map(value =>
        <>
          {data.title == "Price" ?
            // <Slider range min={value?.range_from} max={value?.range_to} allowCross={false} defaultValue={[value?.range_from, value?.range_to]} draggableTrack value={val1} onChange={(e) => setVal1(e)} onAfterChange={(e) => rangefilter(e, data.title)} /> 
            <>
              <MuiSlider
                value={priceRange}
                valueLabelDisplay="auto"
                onChange={handleChange}
                onChangeCommitted={(e, val) => rangefilter(val, data?.title, "mui")}
                min={value?.range_from}
                max={value?.range_to}
                sx={{
                  color: '#ff5722', // main slider color (thumb + track)
                  '& .MuiSlider-thumb': {
                    backgroundColor: '#fff',
                    border: '2px solid #6f7f80',
                  },
                  '& .MuiSlider-rail': {
                    color: '#ccc',
                  },
                  '& .MuiSlider-track': {
                    color: '#6f7f80',
                  },
                }}
              />

              {/* <IonRangeSlider aria-label='carat'
                className="caratdata"
                type={"double"}
                skin={"round"}
                prefix="$"
                min={value.range_from}
                max={value.range_to}
                values={data?.range}
                // onChange={handlecarat}
                onFinish={(e) => rangefilter(e, data.title)}
                from={data.range?.indexOf(Number(val1[0]))}
                to={data.range?.indexOf(Number(val1[1]))}

              /> */}
            </>

            :
            <Slider className="caratdata" range min={0} marks={newRange} step={null} allowCross={false} draggableTrack value={val1} onChange={(e) => setVal1(e)} onAfterChange={(e) => rangefilter(e, data.title, "rc")} />
          }
        </>
      )}
    </Container>
  );
};


export default Productfilter2;
